module.exports = __webpack_public_path__ + "img/emoji08.png";